import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import { store } from './store';

Vue.config.productionTip = false;

new Vue({
  store, // Vuex store
  render: h => h(App)
}).$mount('#app');
